import React, { useEffect, useState } from 'react';
import {
  StyledCheckboxContainer,
  StyledCheckbox,
  StyledCheckmark,
  HiddenCheckbox,
} from './styled';

export interface CheckboxProps {
  text: string;
  disabled?: boolean;
  error?: boolean;
  onCheckboxChange?: (isChecked: boolean) => void;
  onCheckboxClicked?: (isChecked: boolean) => void;
  shouldBeChecked?: boolean;
  setShouldBeChecked?: React.Dispatch<
    React.SetStateAction<boolean | undefined>
  >;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  text,
  disabled,
  error,
  onCheckboxChange,
  onCheckboxClicked,
  shouldBeChecked,
}) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);

  useEffect(() => {
    if (shouldBeChecked !== undefined) {
      setIsChecked(shouldBeChecked);
      if (onCheckboxChange) {
        onCheckboxChange(shouldBeChecked);
      }
    }
  }, [shouldBeChecked]);

  const checkboxWasClicked = (checked: boolean) => {
    setIsChecked(checked);
    if (onCheckboxClicked) {
      onCheckboxClicked(checked);
    }
  };

  return (
    <StyledCheckboxContainer disabled={disabled} error={error}>
      <HiddenCheckbox
        defaultChecked={isChecked}
        onChange={() => checkboxWasClicked(!isChecked)}
        disabled={disabled}
      />
      <StyledCheckbox disabled={disabled} error={error}>
        <StyledCheckmark checked={isChecked} />
      </StyledCheckbox>
      <span>{text}</span>
    </StyledCheckboxContainer>
  );
};
